export default __webpack_public_path__ + "static/media/mastheadLuxury.9430c7f3.svg";